import { extendTheme } from '@chakra-ui/react';

import colors from './colors';
import components from './components';
import styles from './styles';
import typography, { pixelsToRem } from './typography';

const theme = extendTheme({
  colors,
  components,
  fonts: typography.fonts,
  functions: { pixelsToRem },
  styles,
  textStyles: typography,
});

export default theme;
